import { supabase } from 'Services/supabaseClient'

export function getUserCommunities(params) {
  return supabase.rpc('get_user_communities', params)
}

export function getGuestUserCommunities(params) {
  return supabase.rpc('get_guest_communities', params)
}

export function getInternalUserCommunities(params) {
  return supabase.rpc('get_internal_communities', params)
}

export function getReportReasons() {
  return supabase.rpc('get_report_reasons')
}

export function getCommunityMessagesWithAttachments(params) {
  return supabase.rpc('get_community_messages_with_attachments', params)
}

export function addUserToCommunity(params) {
  return supabase.rpc('add_user_to_community', params)
}

export function createMessageWithAttachments(params) {
  return supabase.rpc('create_message_with_attachments', params)
}

export function getPendingUrlMessages(params) {
  return supabase.rpc('get_pending_url_messages', params)
}

export function approveMessageUrl(params) {
  return supabase.rpc('approve_message_url', params)
}

export function rejectMessageUrl(params) {
  return supabase.rpc('reject_message_url', params)
}

export function deleteMessageForMe(params) {
  return supabase.rpc('delete_message_for_me', params)
}

export function deleteMessageForAll(params) {
  return supabase.rpc('delete_message_for_all', params)
}

export function removeMessageForAdmin(params) {
  return supabase.rpc('remove_message', params)
}

export function removeAllMessageForUser(params) {
  return supabase.rpc('remove_all_user_messages', params)
}

export function blockUserFromCommunity(params) {
  return supabase.rpc('block_user_from_community', params)
}

export function reportAbuse(params) {
  return supabase.rpc('report_abuse', params)
}

export function undoReportAbuse(params) {
  return supabase.rpc('undo_report_abuse', params)
}
